import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-arrow-right",
  "use": "icon-icon-arrow-right-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-arrow-right\">\n<g id=\"icon-icon-arrow-right_Group 427323329\">\n<path id=\"icon-icon-arrow-right_Union\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5 13L7 13L7 11L9 11L9 9L11 9L11 7L9 7L9 5L7 5L7 3L5 3L5 5L7 5L7 7L9 7L9 9L7 9L7 11L5 11L5 13Z\" fill=\"white\" fill-opacity=\"0.35\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol